import { enqueueSnackbar } from 'notistack';

import { useApplicationContext } from 'context/ApplicationContext';

type ReturnUseValidationUsuario = {
    validateUsuario: (showError?: boolean) => boolean;
};

export function useValidationUsuario(): ReturnUseValidationUsuario {
    const { user } = useApplicationContext();

    const getFormattedMessage = (messages: string[]): string => {
        return messages.length > 1 ? `${messages.slice(0, -1).join(', ')} e ${messages.slice(-1)}` : messages[0];
    };

    const validateUsuario = (showError = true): boolean => {
        let message = '';

        const { cdUsuario, localFuncionario, tipoEntrega, idCep } = user;
        const messages: string[] = [];

        if (!cdUsuario) {
            messages.push('código do usuário');
        }

        if (!localFuncionario?.idLocalFuncionario) {
            messages.push('local do funcionário');
        }

        if (!tipoEntrega?.idTipoEntrega) {
            messages.push('tipo de entrega');
        }

        if (!idCep) {
            messages.push('endereço');
        }

        if (messages.length) {
            const formattedMessage = getFormattedMessage(messages);

            message = `Cadastro do usuário incompleto, é necessário informar o ${formattedMessage} para efetuar pedidos`;
        }

        if (showError && message) {
            enqueueSnackbar(message, { variant: 'error', autoHideDuration: 5000 });
        }

        return !message;
    };

    return { validateUsuario };
}
